import {
  SupplyShedAggregationType,
  SupplyShedCashCropChoice,
  SupplyShedCoverCropChoice,
  SupplyShedTillageChoice,
} from '@cibo/core'
import { createContext } from 'react'

export interface SupplyShedFiltersContextProps {
  aggregationType: SupplyShedAggregationType
  setAggregationType: (type: SupplyShedAggregationType) => void
  cashCrops?: SupplyShedCashCropChoice[]
  setCashCrops: (cashCrops: SupplyShedCashCropChoice[]) => void
  coverCrop?: SupplyShedCoverCropChoice
  setCoverCrop: (coverCrops?: SupplyShedCoverCropChoice) => void
  tillageTypes?: SupplyShedTillageChoice[]
  setTillageTypes: (tillageTypes: SupplyShedTillageChoice[]) => void
  year?: number
  setYear: (year: number) => void
}

export const SupplyShedFiltersContext = createContext<SupplyShedFiltersContextProps>({
  aggregationType: 'watershed',
  setAggregationType: () => null,
  setCashCrops: () => null,
  setCoverCrop: () => null,
  setTillageTypes: () => null,
  setYear: () => null,
})
SupplyShedFiltersContext.displayName = 'SupplyShedFiltersContext'
